const state = {
  all: [],
  percentAgency: 0.985,
  statuses: {
    payed: {
      id: 'payed',
      name: 'Оплачена',
      color: 'rgba(var(--app-success), 1)'
    },
    noPayed: {
      id: 'noPayed',
      name: 'Не оплачена',
      color: 'rgba(var(--app-danger), 1)'
    },
    payedPart: {
      id: 'payedPart',
      name: 'Частично оплачена',
      color: 'rgba(var(--app-warning), 1)'
    },
    unknown: {
      id: 'unknown',
      name: 'Не известный',
      color: 'rgba(var(--app-primary), 1)'
    }
  }
};

export default state;